export default __webpack_public_path__ + "static/media/mysql.d5bba8da.svg";